<template>
    <b-list-group class="text-dark text-left" style="cursor: pointer;">
        <b-list-group-item v-if="kalameetings.length === 0">
            There are no kalameetings in this list (yet!)
        </b-list-group-item>
        <b-list-group-item v-for="meeting in kalameetings" @click="goToDetails(meeting)"
                           class="d-flex align-items-center mb-4">
            <div class="p-3 mr-3 text-center rounded bg-light">
                <strong>{{ getDate(meeting.date) }}</strong>
                <br>
                <span class="small">{{ getTimeString(meeting.startTime)}}</span>
            </div>
            <div class="kalameetbody" >
                <strong class="small text-dark">
                    From {{ getTimeString(meeting.startTime)}}
                    to {{ getTimeString(meeting.endTime)}}
                </strong><br>
                <h5>{{ meeting.name }}</h5>
                <strong class="small text-dark">
                    By <b>{{ meeting.owner.firstName }} {{ meeting.owner.lastName }}</b>
                </strong><br>
                <strong class="small text-dark">
                    Line starts {{ getTimeDistance(meeting.lineStart) }}
                </strong><br>
                <div class="text-right">
                    <b-badge v-if="meeting.availableTickets === 0"
                             variant="danger">
                        Sold Out
                    </b-badge>
                    <b-badge v-else="meeting.availableTickets < meeting.totalTickets"
                            variant="primary">
                        {{ meeting.availableTickets }} / {{ meeting.totalTickets }}
                        Tickets Available
                    </b-badge>
                </div>
            </div>
        </b-list-group-item>
    </b-list-group>
</template>

<style lang="scss" scoped>
    .kalameetbody {
        width: 100%;
    }
</style>

<script>
import moment from 'moment';

export default {
    name: 'KalameetingList',
    props: [
        'kalameetings'
    ],
    data() {
        return {
            monthNames: [
                'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
                'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
            ]
        };
    },
    methods: {
        getDate(time) {
            const date = new Date(time);
            return `${this.monthNames[date.getMonth()]}, ${date.getDate()}`;
        },
        getTimeString(timeStr) {
            return `${timeStr.split(':')[0]}:${timeStr.split(':')[1]}`;
        },
        getTimeDistance(date) {
            return moment(date).fromNow();
        },
        goToDetails(kalameeting) {
            this.$store.commit('setCurrentKalameeting', kalameeting.id);
            this.$store.commit('setKalameetingDetails', kalameeting);
            if (this.$store.state.currentUser.uid === kalameeting.owner.uid) {
                this.$router.push({ name: 'VIPKalameetingDetails', params: { id: kalameeting.id } });
            } else {
                this.$router.push({ name: 'FANKalameetingDetails', params: { id: kalameeting.id } });
            }
        }
    },
    created() {
        this.$store.dispatch('resetKalameeting');
    }
};
</script>
